export default "__VITE_ASSET__eaf94620__"